import logo from "./logo.svg";
import "./App.css";
import React, { useState, useEffect } from "react";

function App() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeNav, setActiveNav] = useState("home");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    institution: "",
    graduationYear: "",
    location: "",
    budgetRange: "",
    message: "",
  });
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const handleFormChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    // Form submission logic would go here
    alert("Thank you for your interest! We will contact you shortly.");
    setFormData({
      name: "",
      email: "",
      phone: "",
      institution: "",
      graduationYear: "",
      location: "",
      message: "",
    });
  };
  return (
    <div className=" text-gray-800 overflow-x-hidden">
      <link
        href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&display=swap"
        rel="stylesheet"
      />
      <link href="https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap" rel="stylesheet"></link>
      {/* Header */}
      <header
        className={`fixed w-full z-50 transition-all duration-300 ${
          isScrolled ? "bg-[#1B365D] shadow-lg" : "bg-transparent"
        }`}
      >
        <div className="container mx-auto px-4 sm:px-6 py-3 sm:py-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <h1 className="text-xl sm:text-2xl font-bold text-white">
                Elite Alumni Housing
              </h1>
            </div>
            {/* Desktop Navigation */}
            <nav className="hidden md:flex space-x-8">
              {[
                "Home",
                "Vision",
                "Benefits",
                "Locations",
                "Register",
                "Team",
                "Contact",
              ].map((item) => (
                <a
                  key={item}
                  href={`#${
                    item.toLowerCase() === "team" ? "about" : item.toLowerCase()
                  }`}
                  className="text-white hover:text-[#C5A572] transition-colors duration-300 cursor-pointer whitespace-nowrap"
                  onClick={() => {
                    setActiveNav(item.toLowerCase());
                    if (item.toLowerCase() === "team") {
                      const aboutSection = document.getElementById("about");
                      if (aboutSection) {
                        aboutSection.scrollIntoView({ behavior: "smooth" });
                      }
                    }
                  }}
                >
                  {item}
                </a>
              ))}
            </nav>
            {/* Mobile Navigation Toggle */}
            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-white focus:outline-none cursor-pointer whitespace-nowrap"
              >
                <i
                  className={`fas ${
                    isMenuOpen ? "fa-times" : "fa-bars"
                  } text-2xl`}
                ></i>
              </button>
            </div>
          </div>
          {/* Mobile Navigation Menu */}
          {isMenuOpen && (
            <div className="md:hidden mt-4 bg-[#1B365D] rounded-lg shadow-xl p-4">
              <div className="flex flex-col space-y-4">
                {[
                  "Home",
                  "Vision",
                  "Benefits",
                  "Locations",
                  "Register",
                  "Team",
                  "Contact",
                ].map((item) => (
                  <a
                    key={item}
                    href={`#${item.toLowerCase()}`}
                    className="text-white hover:text-[#C5A572] transition-colors duration-300 cursor-pointer whitespace-nowrap"
                    onClick={() => {
                      setActiveNav(item.toLowerCase());
                      setIsMenuOpen(false);
                    }}
                  >
                    {item}
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>
      </header>
      {/* Hero Section */}
      <section
        id="home"
        className="relative min-h-screen flex items-center py-32 sm:py-20 md:py-0"
      >
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://static.readdy.ai/image/ab954453793a8aab17ef0c69edbbca88/91d8ff3f4e01366d46f4acf83e892b67.png')`,
          }}
        ></div>
        <div className="absolute inset-0 bg-[#1B365D] opacity-70"></div>
        <div className="container mx-auto px-4 sm:px-6 z-10 relative">
          <div className="max-w-3xl">
            <h1 className="font-['Playfair_Display'] text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-4 leading-tight font-['Playfair_Display'] tracking-wide">
              Own Premium Housing
              <br />
              with Elite College Alumni
            </h1>
            <div className="w-20 h-1 bg-[#C5A572] mb-6"></div>
            <p className="font-['Playfair_Display'] text-lg sm:text-xl md:text-2xl text-white mb-8 leading-relaxed">
              Exclusive Plot & Housing Projects by the alumni and for the alumni
              of premier institutions. Get involved as co-developers to get
              highly discounted pricing.
            </p>
            <button
              onClick={() => {
                document
                  .getElementById("register")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
              className="w-full sm:w-auto bg-[#C5A572] text-white px-6 sm:px-8 py-3 rounded-button text-base sm:text-lg hover:bg-[#b3935d] transition-all duration-300 shadow-lg cursor-pointer whitespace-nowrap"
            >
              Express Your Interest
            </button>
          </div>
        </div>
      </section>
      {/* Vision Section */}
      <section id="vision" className="py-20 bg-white relative">
        <div className="absolute inset-0 opacity-10">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20global%20city%20skyline%20at%20dusk%20with%20iconic%20skyscrapers%20and%20illuminated%20buildings%2C%20showing%20professional%20networking%20event%20with%20diverse%20group%20of%20alumni%20in%20foreground%2C%20elegant%20rooftop%20venue%20with%20panoramic%20views%2C%20sophisticated%20atmosphere%20with%20subtle%20lighting&width=1920&height=1080&seq=vision1&orientation=landscape"
            alt="Global Alumni Network"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-[#1B365D] mb-6">
              Our Vision
            </h2>
            <div className="w-16 h-1 bg-[#C5A572] mx-auto mb-8"></div>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto">
              To enable elite college alumni to purchase residential real estate
              together with like-minded alumni; while offering lifelong
              relationships and a powerful network.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
            {[
              {
                icon: "fa-home",
                title: "Premium Living",
                description:
                  "Meticulously designed residential projects with premium amenities and high quality development that reflect your Aspirations and Status",
              },
              {
                icon: "fa-users",
                title: "Lowered Risk",
                description:
                  "Everyone aspires to invest in Real Estate, but not everyone understands it. With our co-development model, collective wisdom of the brightest minds enable intelligent and safer investments",
              },
              {
                icon: "fa-chart-line",
                title: "Heavily Discounted",
                description:
                  "Leverage the Alumni network's Access, Capabilities & Trust to get significantly lower pricing compared to prevailing market rates, ensuring sure-shot financial upside.",
              },
            ].map((pillar, index) => (
              <div
                key={index}
                className="bg-gray-50 rounded-lg p-8 transition-all duration-300 hover:transform hover:scale-105 hover:shadow-lg"
              >
                <div className="w-16 h-16 rounded-full  bg-opacity-10 flex items-center justify-center mb-6 mx-auto">
                  <i className={`fa-solid ${pillar.icon}  text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-[#1B365D] mb-4 text-center">
                  {pillar.title}
                </h3>
                <p className="text-gray-600 text-center">
                  {pillar.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* How It Works Section */}
      <section className="py-20 bg-[#1B365D] text-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-white mb-6">How It Works</h2>
            <div className="w-16 h-1 bg-[#C5A572] mx-auto mb-8"></div>
            <p className="text-gray-300 max-w-3xl mx-auto">
              Our unique co-development model ensures transparency, capital
              protection, and accelerated project completion.
            </p>
          </div>
          <div className="relative">
            <div className="absolute left-0 right-0 top-1/2 transform -translate-y-1/2">
              <div className="h-1 bg-[#C5A572] w-full opacity-20"></div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-5 gap-8 relative">
              {[
                {
                  step: 1,
                  title: "Alumni Join Early",
                  icon: "fa-users",
                  description:
                    "Alumni join at concept stage, ensuring maximum benefits and early-bird pricing advantages",
                },
                {
                  step: 2,
                  title: "Co-ownership Structure",
                  icon: "fa-handshake",
                  description:
                    "Funds pooled with developer for land acquisition through transparent co-ownership structure",
                },
                {
                  step: 3,
                  title: "Structured Payments",
                  icon: "fa-money-bill-wave",
                  description:
                    "80% payable pre-RERA registration, remaining 20% post-RERA approval",
                },
                {
                  step: 4,
                  title: "Legal Safeguards",
                  icon: "fa-shield-alt",
                  description:
                    "Land & share pledges with comprehensive legal safeguards protect investor interests",
                },
                {
                  step: 5,
                  title: "Alumni Oversight",
                  icon: "fa-clipboard-check",
                  description:
                    "Project monitored by alumni-led committee ensuring quality and timely delivery",
                },
              ].map((step, index) => (
                <div
                  key={index}
                  className="bg-white p-6 rounded-lg shadow-lg relative z-10"
                >
                  <div className="w-16 h-16 bg-[#1B365D] bg-opacity-10 rounded-full flex items-center justify-center mb-6 mx-auto">
                    <i className={`fa-solid ${step.icon} text-2xl `}></i>
                  </div>
                  <h3 className="text-lg font-bold text-[#1B365D] mb-4 text-center">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-center text-sm">
                    {step.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      {/* Benefits Section */}
      <section id="benefits" className="py-20 relative">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20luxury%20residential%20community%20amenities%20view%20with%20infinity%20pool%2C%20landscaped%20gardens%2C%20and%20contemporary%20architecture%2C%20showing%20premium%20lifestyle%20features%20with%20soft%20natural%20lighting%20and%20elegant%20design%20elements%2C%20minimal%20and%20sophisticated%20atmosphere&width=1920&height=1080&seq=benefits1&orientation=landscape"
            alt="Benefits Background"
            className="w-full h-full object-cover object-center opacity-10"
          />
        </div>
        <div className="container mx-auto px-6 relative">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-[#1B365D] mb-6">
              Benefits with Elite Alumni Housing
            </h2>
            <div className="w-16 h-1 bg-[#C5A572] mx-auto mb-8"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-lg shadow-lg border border-gray-100 hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16  bg-opacity-10 rounded-full flex items-center justify-center mb-6">
                <i className="fa-solid fa-users text-2xl "></i>
              </div>
              <h3 className="text-xl font-bold text-[#1B365D] mb-4">
                Exclusive Community
              </h3>
              <p className="text-gray-600">
                Join a carefully curated community of elite college alumni who
                share your values, aspirations, and lifestyle preferences.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-lg border border-gray-100 hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16  bg-opacity-10 rounded-full flex items-center justify-center mb-6">
                <i class="fa-solid fa-chart-line fa-xl "></i>
              </div>
              <h3 className="text-xl font-bold text-[#1B365D] mb-4">
                Transparent Pricing
              </h3>
              <p className="text-gray-600">
                Benefit from co-development pricing model with guaranteed day
                zero upside compared to current market rates.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-lg border border-gray-100 hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16  bg-opacity-10 rounded-full flex items-center justify-center mb-6">
                <i className="fa-solid fa-star text-xl "></i>
              </div>
              <h3 className="text-xl font-bold text-[#1B365D] mb-4">
                Quick Turnaround
              </h3>
              <p className="text-gray-600">
                No project debt ensures financial stability and timely funding
                enables faster completion
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-lg border border-gray-100 hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16  bg-opacity-10 rounded-full flex items-center justify-center mb-6">
                <i className="fa-solid fa-map-marker-alt text-xl "></i>
              </div>
              <h3 className="text-xl font-bold text-[#1B365D] mb-4">
                Location Selection
              </h3>
              <p className="text-gray-600">
                Locations are finalized based on maximum alumni consensus,
                ensuring community preferences are prioritized.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-lg border border-gray-100 hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16  bg-opacity-10 rounded-full flex items-center justify-center mb-6">
              <i className="fa-solid fa-clipboard-check"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1B365D] mb-4">
                Quality Control
              </h3>
              <p className="text-gray-600">
                Rigorous project management and quality control measures ensure
                the highest standards of construction and delivery.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-lg border border-gray-100 hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16  bg-opacity-10 rounded-full flex items-center justify-center mb-6">
                <i className="fa-solid fa-handshake text-2xl "></i>
              </div>
              <h3 className="text-xl font-bold text-[#1B365D] mb-4">
                Investment Growth
              </h3>
              <p className="text-gray-600">
                Strategic location selection and premium development ensure
                strong potential for property value appreciation.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Locations Section */}
      <section id="locations" className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-[#1B365D] mb-6">
              Where Would You Want to Live?
            </h2>
            <div className="w-16 h-1 bg-[#C5A572] mx-auto mb-8"></div>
            <p className="text-gray-700 max-w-3xl mx-auto">
              Locations will be finalized based on maximum alumni interest.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 px-2 sm:px-0">
            {[
              {
                name: "Gurugram",
                image:
                  "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Gurugram%20cityscape%20with%20modern%20skyscrapers%2C%20Cyber%20Hub%2C%20Golf%20Course%20Road%2C%20and%20iconic%20landmarks%20during%20golden%20hour%2C%20showcasing%20the%20vibrant%20urban%20development%20against%20clear%20sky&width=500&height=300&seq=loc1&orientation=landscape",
              },
              {
                name: "Bengaluru",
                image:
                  "https://readdy.ai/api/search-image?query=Panoramic%20view%20of%20Bangalore%20city%20with%20Vidhana%20Soudha%2C%20Cubbon%20Park%20greenery%2C%20and%20tech%20parks%2C%20showing%20the%20garden%20city%20charm%20mixed%20with%20modern%20infrastructure%20against%20blue%20sky&width=500&height=300&seq=loc2&orientation=landscape",
              },
              {
                name: "Bhopal",
                image:
                  "https://readdy.ai/api/search-image?query=Beautiful%20cityscape%20of%20Bhopal%20with%20Upper%20Lake%2C%20Van%20Vihar%2C%20and%20historic%20architecture%2C%20showing%20the%20city%20of%20lakes%20with%20lush%20greenery%20and%20modern%20development%20against%20clear%20sky&width=500&height=300&seq=loc3&orientation=landscape",
              },
              {
                name: "Indore",
                image:
                  "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Indore%20city%20showing%20Rajwada%20Palace%2C%20modern%20infrastructure%2C%20and%20clean%20wide%20roads%2C%20highlighting%20the%20cleanest%20city%20status%20with%20blend%20of%20heritage%20and%20development%20against%20blue%20sky&width=500&height=300&seq=loc4&orientation=landscape",
              },
              {
                name: "Jaipur",
                image:
                  "https://readdy.ai/api/search-image?query=Majestic%20view%20of%20Pink%20City%20Jaipur%20with%20Amber%20Fort%2C%20City%20Palace%2C%20and%20modern%20development%2C%20showcasing%20the%20royal%20heritage%20mixed%20with%20contemporary%20growth%20against%20clear%20desert%20sky&width=500&height=300&seq=loc7&orientation=landscape",
              },
              {
                name: "Pune",
                image:
                  "https://readdy.ai/api/search-image?query=Panoramic%20view%20of%20Pune%20city%20with%20Sinhagad%20Fort%20in%20background%2C%20IT%20parks%2C%20and%20university%20area%2C%20showing%20the%20educational%20hub%20with%20modern%20infrastructure%20against%20clear%20blue%20sky&width=500&height=300&seq=loc6&orientation=landscape",
              },
              {
                name: "Dehradun",
                image:
                  "https://readdy.ai/api/search-image?query=Scenic%20view%20of%20Dehradun%20valley%20with%20Himalayan%20backdrop%2C%20FRI%20building%2C%20and%20modern%20development%2C%20showcasing%20the%20perfect%20blend%20of%20nature%20and%20urban%20growth%20against%20clear%20mountain%20sky&width=500&height=300&seq=loc5&orientation=landscape",
              },
              {
                name: "Lucknow",
                image:
                  "https://readdy.ai/api/search-image?query=Cityscape%20of%20Lucknow%20with%20Bara%20Imambara%2C%20Gomti%20Riverfront%2C%20and%20modern%20infrastructure%2C%20showing%20the%20city%20of%20Nawabs%20with%20contemporary%20development%20against%20clear%20evening%20sky&width=500&height=300&seq=loc8&orientation=landscape",
              },
            ].map((location, index) => (
              <div
                key={index}
                className="bg-white rounded-lg overflow-hidden shadow-lg transition-all duration-300 hover:shadow-xl cursor-pointer group"
              >
                <div className="relative h-40 overflow-hidden">
                  <img
                    src={location.image}
                    alt={location.name}
                    className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                <div className="p-4 flex justify-between items-center">
                  <h3 className="text-lg font-bold text-[#1B365D]">
                    {location.name}
                  </h3>
                  {/* <button
onClick={() => {
document.getElementById('register')?.scrollIntoView({ behavior: 'smooth' });
const locationSelect = document.getElementById('location-select') as HTMLSelectElement;

if (locationSelect) {
locationSelect.value = location.name;
// Trigger onChange to update React state
const event = new Event('change', { bubbles: true });
locationSelect.dispatchEvent(event);
}
}}
className="bg-[#C5A572] text-white px-3 py-2 rounded-button text-sm hover:bg-[#b3935d] transition-colors duration-300 cursor-pointer whitespace-nowrap"
>
Express Interest
</button> */}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Project Features Section */}
      <section className="py-20 relative">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20luxury%20residential%20community%20with%20contemporary%20clubhouse%2C%20wellness%20center%2C%20and%20sports%20facilities%2C%20featuring%20elegant%20architecture%2C%20landscaped%20gardens%2C%20and%20premium%20amenities%2C%20showing%20sophisticated%20lifestyle%20spaces%20in%20soft%20natural%20lighting&width=1920&height=1080&seq=features1&orientation=landscape"
            alt="Project Features Background"
            className="w-full h-full object-cover object-center opacity-10"
          />
        </div>
        <div className="container mx-auto px-6 relative">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-[#1B365D] mb-6">
              Project Features
            </h2>
            <div className="w-16 h-1 bg-[#C5A572] mx-auto mb-8"></div>
            <p className="text-gray-700 max-w-3xl mx-auto">
              Our initial focus is on Plotted developments, with later expansion
              into constructed villas and high-rise apartments, based on Alumni
              interest
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-8 mb-8 sm:mb-16 px-2 sm:px-0">
            <div className="bg-white bg-opacity-90 p-4 sm:p-8 rounded-lg shadow-lg">
              <h3 className="text-lg sm:text-xl font-bold text-[#1B365D] mb-4 flex items-center">
                <i className="fas fa-map-marked-alt text-[#C5A572] mr-3 text-xl sm:text-2xl"></i>
                Strategic Locations
              </h3>
              <p className="text-sm sm:text-base text-gray-700">
                Situated within active development hubs, our projects offer
                excellent connectivity to airports, markets, and key city
                landmarks.
              </p>
            </div>
            <div className="bg-white bg-opacity-90 p-4 sm:p-8 rounded-lg shadow-lg">
              <h3 className="text-lg sm:text-xl font-bold text-[#1B365D] mb-4 flex items-center">
                <i className="fas fa-ruler-combined text-[#C5A572] mr-3 text-xl sm:text-2xl"></i>
                Development Specifications
              </h3>
              <ul className="space-y-2 sm:space-y-3 text-sm sm:text-base text-gray-700">
                <li className="flex items-center">
                  <i className="fas fa-check text-[#C5A572] mr-2 flex-shrink-0"></i>
                  <span>Development Size: 5–10 acres</span>
                </li>
                <li className="flex items-center">
                  <i className="fas fa-check text-[#C5A572] mr-2 flex-shrink-0"></i>
                  <span>Plot Size: 2,000 to 5,000 sq. ft.</span>
                </li>
                <li className="flex items-center">
                  <i className="fas fa-check text-[#C5A572] mr-2 flex-shrink-0"></i>
                  <span>Professionally Planned Campuses</span>
                </li>
                <li className="flex items-center">
                  <i className="fas fa-check text-[#C5A572] mr-2 flex-shrink-0"></i>
                  <span>High Quality Materials</span>
                </li>
                <li className="flex items-center">
                  <i className="fas fa-check text-[#C5A572] mr-2 flex-shrink-0"></i>
                  <span>Special Focus on Security & Aesthetics</span>
                </li>
                <li className="flex items-center">
                  <i className="fas fa-check text-[#C5A572] mr-2 flex-shrink-0"></i>
                  <span>Optional Villa Construction & PMC Services</span>
                </li>
              </ul>
            </div>
            <div className="bg-white bg-opacity-90 p-4 sm:p-8 rounded-lg shadow-lg">
              <h3 className="text-lg sm:text-xl font-bold text-[#1B365D] mb-4 flex items-center">
                <i className="fas fa-star text-[#C5A572] mr-3 text-xl sm:text-2xl"></i>
                Key Amenities
              </h3>
              <div className="space-y-2 sm:space-y-3">
                <div className="flex items-center">
                  <i className="fas fa-dumbbell text-[#C5A572] mr-2 flex-shrink-0"></i>
                  <span className="text-sm sm:text-base text-gray-700">
                    Premium Club with Sports & Wellness
                  </span>
                </div>
                <div className="flex items-center">
                  <i className="fas fa-laptop text-[#C5A572] mr-2 flex-shrink-0"></i>
                  <span className="text-sm sm:text-base text-gray-700">
                    Co-working Spaces
                  </span>
                </div>
                <div className="flex items-center">
                  <i className="fas fa-utensils text-[#C5A572] mr-2 flex-shrink-0"></i>
                  <span className="text-sm sm:text-base text-gray-700">
                    Community Dining & Event Areas
                  </span>
                </div>
                <div className="flex items-center">
                  <i className="fas fa-bed text-[#C5A572] mr-2 flex-shrink-0"></i>
                  <span className="text-sm sm:text-base text-gray-700">
                    Serviced Guest Suites
                  </span>
                </div>
                <div className="flex items-center">
                  <i className="fas fa-heartbeat text-[#C5A572] mr-2 flex-shrink-0"></i>
                  <span className="text-sm sm:text-base text-gray-700">
                    Senior Living: OPD & Physio Tie-ups
                  </span>
                </div>
                <div className="flex items-center">
                  <i className="fas fa-child text-[#C5A572] mr-2 flex-shrink-0"></i>
                  <span className="text-sm sm:text-base text-gray-700">
                    Kids: Sports Training & Play Areas
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white bg-opacity-90 p-8 rounded-lg shadow-lg">
            <h3 className="text-2xl font-bold text-[#1B365D] mb-8 text-center">
              Project Milestones
            </h3>
            <div className="relative">
              <div className="hidden md:block absolute top-[24px] left-0 right-0 h-1 bg-[#C5A572]"></div>
              <div className="md:hidden absolute left-[24px] top-0 bottom-0 w-1 bg-[#C5A572]"></div>
              <div className="relative z-10 grid grid-cols-1 md:grid-cols-6 gap-8 md:gap-4">
                {[
                  { icon: "fa-users", title: "EOI Collection" },
                  { icon: "fa-map-marker-alt", title: "Location Finalization" },
                  { icon: "fa-building", title: "Land Acquisition" },
                  { icon: "fa-file-contract", title: "Govt Approvals" },
                  { icon: "fa-hard-hat", title: "Construction" },
                  { icon: "fa-key", title: "Possession" },
                ].map((milestone, index) => (
                  <div key={index} className="flex md:flex-col items-center">
                    <div className="w-12 h-12 rounded-full bg-[#1B365D] flex items-center justify-center mb-0 md:mb-4 mr-4 md:mr-0 flex-shrink-0">
                      <i
                        className={`fas ${milestone.icon} text-[#C5A572] text-xl`}
                      ></i>
                    </div>
                    <div className="bg-[#1B365D] text-white px-4 md:px-3 py-2 rounded-lg text-sm text-center whitespace-nowrap flex-grow md:flex-grow-0">
                      {milestone.title}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Register Section */}
      <section id="register" className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-xl overflow-hidden mx-2 sm:mx-auto">
            <div className="flex flex-col md:flex-row">
              <div className="md:w-1/2 bg-[#1B365D] p-6 sm:p-10 text-white">
                <h2 className="text-3 xl font-bold mb-6">
                  Express Your Interest
                </h2>
                <div className="w-16 h-1 bg-[#C5A572] mb-8"></div>
                <p className="mb-6">
                  Join our exclusive community of elite alumni. Register your
                  interest today to receive priority access to our upcoming
                  projects.
                </p>
                <div className="space-y-4">
                  <div className="flex items-center">
                    <i className="fas fa-check-circle text-[#C5A572] mr-3"></i>
                    <span>Premium Locations</span>
                  </div>
                  <div className="flex items-center">
                    <i className="fas fa-check-circle text-[#C5A572] mr-3"></i>
                    <span>Early Bird Pricing</span>
                  </div>
                  <div className="flex items-center">
                    <i className="fas fa-check-circle text-[#C5A572] mr-3"></i>
                    <span>Priority Plot Selection</span>
                  </div>
                  <div className="flex items-center">
                    <i className="fas fa-check-circle text-[#C5A572] mr-3"></i>
                    <span>Exclusive Community Benefits</span>
                  </div>
                </div>
              </div>
              <div className="md:w-1/2 p-6 sm:p-8 md:p-10">
                <form
                  action="https://elitealumnihousing.com/admin/alumnihousing_query"
                  method="post"
                  className="space-y-4 sm:space-y-6"
                >
                  <div>
                    <label className="block text-gray-700 text-sm font-medium mb-2">
                      Full Name
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleFormChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-[#1B365D] text-base"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700 text-sm font-medium mb-2">
                      Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleFormChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-[#1B365D]"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700 text-sm font-medium mb-2">
                      Phone
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleFormChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-[#1B365D]"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700 text-sm font-medium mb-2">
                      Institution
                    </label>
                    <input
                      type="text"
                      name="institution"
                      value={formData.institution}
                      onChange={handleFormChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-[#1B365D]"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700 text-sm font-medium mb-2">
                      Graduation Year
                    </label>
                    <input
                      type="text"
                      name="graduation"
                      value={formData.graduation}
                      onChange={handleFormChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-[#1B365D]"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700 text-sm font-medium mb-2">
                      Preferred Location
                    </label>
                    <select
                      id="location-select"
                      name="location"
                      value={formData.location}
                      onChange={handleFormChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-[#1B365D]"
                      required
                    >
                      <option value="">Select Location</option>
                      <option value="Gurugram">Gurugram</option>
                      <option value="Bengaluru">Bengaluru</option>
                      <option value="Bhopal">Bhopal</option>
                      <option value="Indore">Indore</option>
                      <option value="Dehradun">Dehradun</option>
                      <option value="Pune">Pune</option>
                      <option value="Jaipur">Jaipur</option>
                      <option value="Lucknow">Lucknow</option>
                      <option value="Hyderabad">Hyderabad</option>
                      <option value="Patna">Patna</option>
                      <option value="Ranchi">Ranchi</option>
                      <option value="Raipur">Raipur</option>
                      <option value="Noida">Noida</option>
                      <option value="Faridabad">Faridabad</option>
                      <option value="Chandigarh / Mohali">Chandigarh / Mohali</option>
                      <option value="Ludhiana">Ludhiana</option>
                      <option value="Jammu">Jammu</option>
                      <option value="Delhi">Delhi</option>
                      <option value="Ahmedabad">Ahmedabad</option>
                      <option value="Kolkata">Kolkata</option>
                      <option value="Other">Other</option>


                    </select>
                  </div>
                  <div>
                    <label className="block text-gray-700 text-sm font-medium mb-2">
                      Budget Range
                    </label>
                    <select
                      name="budget"
                      value={formData.budget}
                      onChange={handleFormChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-[#1B365D]"
                      required
                    >
                      <option value="">Select Budget Range</option>
                      <option value="30-50L">30-50 Lakhs</option>
                      <option value="50-75L">50-75 Lakhs</option>
                      <option value="75L-1Cr">75 Lakhs - 1 Crore</option>
                      <option value="Rs 1 - 1.5 Crore">Rs 1 - 1.5 Crore</option>
                      <option value="Rs 1.5 - 2 Crore">Rs 1.5 - 2 Crore</option>
                      <option value="Rs 2 Crore +">Rs 2 Crore +</option>

                          </select>
                  </div>
                  <div>
                    <label className="block text-gray-700 text-sm font-medium mb-2">
                      Unit Type
                    </label>
                    <select
                      name="unit"
                      value={formData.unit}
                      onChange={handleFormChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-[#1B365D]"
                      required
                    >
                      <option value="">Select Unit Type</option>
                      <option value="Plot">Plot</option>
                      <option value="Independent House">Independent House</option>
                      <option value="Apartment">Apartment</option>
                     

                          </select>
                  </div>
                  <div>
                    <label className="block text-gray-700 text-sm font-medium mb-2">
                      Message (Optional)
                    </label>
                    <textarea
                      name="msg"
                      value={formData.msg}
                      onChange={handleFormChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-[#1B365D]"
                      rows={4}
                    ></textarea>
                  </div>
                  <button
                    type="submit"
                    className="w-full bg-[#C5A572] text-white px-6 py-3 rounded-button hover:bg-[#b3935d] transition-colors duration-300"
                  >
                    Submit Interest
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
 <section className="py-20 relative">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20luxury%20residential%20community%20with%20contemporary%20clubhouse%2C%20wellness%20center%2C%20and%20sports%20facilities%2C%20featuring%20elegant%20architecture%2C%20landscaped%20gardens%2C%20and%20premium%20amenities%2C%20showing%20sophisticated%20lifestyle%20spaces%20in%20soft%20natural%20lighting&width=1920&height=1080&seq=features1&orientation=landscape"
            alt="Project Features Background"
            className="w-full h-full object-cover object-center opacity-10"
          />
        </div>
        <div className="container mx-auto px-6 relative">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-[#1B365D] mb-6">
              Frequently Asked Questions (FAQs)
            </h2>
            <div className="w-16 h-1 bg-[#C5A572] mx-auto mb-8"></div>
            <p className="text-gray-700 max-w-3xl mx-auto">
             Curated living by and for alumni of top institutions.
We will keep updating the FAQs as we move forward in the journey and get more questions from the
interested buyers
            </p>
          </div>
           <div class="flex flex-wrap lg:w-4/5 sm:mx-auto sm:mb-2 -mx-2">
            <div class="w-full lg:w-1/2 px-4 py-2">
              <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                  What is Elite Alumni Housing?
                </summary>

                <span>
                  Elite Alumni Housing is a collective initiative where alumni from India's and the world's top institutions
co-create high-quality residential communities
                </span>
              </details>
              <details class="mb-4">
                <summary class="font-semibold bg-gray-200 rounded-md py-2 px-4">
                  What makes this different from traditional real estate?
                </summary>

                <span>
                  Unlike builder-led models, this is alumni-driven. Buyers form an LLP to pool funds, acquire land, and oversee
the project. It ensures: <br/>
- Rock-bottom pricing<br/>
- Transparency<br/>
- Shared interest alignment
                </span>
              </details>
              <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                Who can join?
                </summary>

                <span>
                 Alumni from IIT, IIM, BITS, ISB, AIIMS, INSEAD, NUS, Ivy League, etc. At seed stage, only alumni. 50-60%
inventory reserved.
                </span>
              </details>
               <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                What is the legal structure of this initiative?
                </summary>

                <span>
                 LLP (Limited Liability Partnership) formed after 100+ EOIs. It pools funds, monitors project, and holds
pledges
                </span>
              </details>
               <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                What is the LLP's role during execution?
                </summary>

                <span>
                 LLP ensures timely fund collection and land/construction payments. Execution is led by the developer.
                </span>
              </details>
               <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                Who is the lead developer?
                </summary>

                <span>
                Digendra Rathore (Elite Alumni Housing). Local builders and co-developers will be brought in for execution.
                </span>
              </details>
               <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                Who will monitor the project?

                </summary>

                <span>
                 Monitoring Committee with volunteer buyers + permanent advisory board will oversee progress
                </span>
              </details>
               <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                Will the LLP retain any profit?
                </summary>

                <span>
                 No. Surpluses are redistributed among members or used to reduce construction cost.
                </span>
              </details>
               <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                Can government or PSU employees participate?
                </summary>

                <span>
                Yes. Preferred structure is for a non-government family member to hold LLP share
                </span>
              </details>
               <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                 Can NRIs or OCIs participate?
                </summary>

                <span>
                Yes, if funds come from Rupee accounts. Foreign remittance involves additional RBI compliance.
                </span>
              </details>
               <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                 Can I choose my unit or floor?
                </summary>

                <span>
                Yes, subject to availability. PLC (Preferential Location Charges) may apply
                </span>
              </details>
               <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                 Can I purchase multiple or Jodi flats?
                </summary>

                <span>
                Yes. Subject to availability
                </span>
              </details>
               <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                 Will bank loans be available?
                </summary>

                <span>
                Yes, post-RERA for construction-linked payments. Pre-RERA needs self-funding
                </span>
              </details>
               <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                 What if construction costs rise?

                </summary>

                <span>
               Minor inflation absorbed by developer. LLP ensures transparency
                </span>
              </details>
               <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                How will GST, TDS, etc., be handled?

                </summary>

                <span>
                By professional CA team and alumni experts from tax/customs services.
                </span>
              </details>
               <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                 Will LLP shares be dematerialized?
                </summary>

                <span>
                No. Not needed for a small private LLP.
                </span>
              </details>
               <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                 Can I sell my flat in future?

                </summary>

                <span>
                Yes. Free sale allowed after 24-month post-RERA lock-in.
                </span>
              </details>
               <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                 What happens to LLP after handover?
                </summary>

                <span>
                Can be dissolved or converted into facility management company.
                </span>
              </details>
               <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                 Who will build the project?
                </summary>

                <span>
                Contractor appointed by developer. Local expertise prioritized.
                </span>
              </details>
            </div>
            <div class="w-full lg:w-1/2 px-4 py-2">
              <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                 How do I join?

                </summary>

                <span class="px-4 py-2">
                  Join open WhatsApp group. After land options shared, submit firm EOI with Rs 1 lakh token. LLP registered
after 100+ EOIs.
                </span>
              </details>
              <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                  How much do I need to invest upfront?
                </summary>

                <span class="px-4 py-2">
                 Plotting: 80-90% before RERA. Housing: 60-70% before RERA. Cost ranges Rs 40L-Rs 2.5Cr+.
                </span>
              </details>
              <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                  Why contribute early instead of waiting for RERA?
                </summary>

                <span class="px-4 py-2">
                 - Lowest entry price <br/>
- LLP rights<br/>
- Early mover benefits<br/>
- Land/share pledges for protection
                </span>
              </details>
              <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                  Where is the project located?
                </summary>

                <span class="px-4 py-2">
                 Not yet finalized. Land scouting will begin after 100+ EOIs.
                </span>
              </details>
              <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                 What is the size and cost of land?
                </summary>

                <span class="px-4 py-2">
                Will depend on city. Typically 5-10 acres. Cost shared before firm commitments.
                </span>
              </details>
              <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                   How is my investment protected?
                </summary>

                <span class="px-4 py-2">
                 - Legal pledge on land and land-holding entity<br/>
- Controlled fund release<br/>
- Real-time updates 
                </span>
              </details>
              <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                  What if I want to exit before RERA?
                </summary>

                <span class="px-4 py-2">
                 Refund issued after new buyer confirms and pays in full.
                </span>
              </details>
              <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                  What if I want to exit after RERA?
                </summary>

                <span class="px-4 py-2">
                24-month lock-in applies post-RERA. After that, you may exit per Builder-Buyer Agreement
                </span>
              </details>
              <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                  What is the expected project timeline?
                </summary>

                <span class="px-4 py-2">
                 Plotting: 1-2 years post-RERA. Housing: 2-4 years depending on scope.
                </span>
              </details>
              <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                 What's the process from EOI to possession?
                </summary>

                <span class="px-4 py-2">
                 - Join WhatsApp group<br/>
- Submit EOI<br/>
- Land finalization<br/>
- LLP registration<br/>
- RERA<br/>
- Construction<br/>
- Possession <br/>

                </span>
              </details>
               <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                  What if LLP doesn't get 100 EOIs?
                </summary>

                <span class="px-4 py-2">
                Project won't proceed. No obligation until land/payout confirmed.
                </span>
              </details>
               <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                  How will land be finalized?
                </summary>

                <span class="px-4 py-2">
                 Shared with buyers post-EOI. Finalization based on feedback.
                </span>
              </details>
               <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                  Does LLP manage construction directly?
                </summary>

                <span class="px-4 py-2">
                No. Developer leads, LLP monitors fund usage and progress.
                </span>
              </details>
               <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                 Will there be a PMC (Project Management Consultant)?
                </summary>

                <span class="px-4 py-2">
                 Yes, if needed. Ensures quality, cost control, and tracking.
                </span>
              </details>
               <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                 What if land prices rise?
                </summary>

                <span class="px-4 py-2">
                Options will be evaluated. Buyer's approval taken before any change.
                </span>
              </details>
               <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                  Can the project be dropped post-scouting?

                </summary>

                <span class="px-4 py-2">
                 Yes. Refunds issued if land or buyers not confirmed
                </span>
              </details>
               <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                  Who manages the initiative pre-LLP?
                </summary>

                <span class="px-4 py-2">
                 Digendra Rathore and a core alumni team manage planning and outreach
                </span>
              </details>
               <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                 Is there a group to engage with other buyers?
                </summary>

                <span class="px-4 py-2">
                 Yes. Open WhatsApp groups exist for each city. Closed groups created post-EOI.
                </span>
              </details>
               <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                 What legal documents will I sign?

                </summary>

                <span class="px-4 py-2">
                 - EOI form<br/>
                 - Token agreement post-land finalization<br/>
- LLP agreement + shareholding terms

                </span>
              </details>
            </div>
          </div>
          
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-[#1B365D] mb-6">Team</h2>
            <div className="w-16 h-1 bg-[#C5A572] mx-auto mb-8"></div>
          </div>
          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-gray-50 p-8 rounded-lg hover:shadow-lg transition-shadow duration-300">
              <h3 className="text-xl font-bold text-[#1B365D] mb-6">Founder</h3>
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 rounded-full bg-[#1B365D] bg-opacity-10 flex items-center justify-center">
                    <i className="fas fa-user-tie text-2xl text-[#C5A572]"></i>
                  </div>
                </div>
                <div>
                  <h4 className="font-semibold text-[#1B365D] text-lg mb-2">
                    Digendra Singh Rathore
                  </h4>
                  <p className="text-gray-600 mb-2">IIT Roorkee 2013 alumnus</p>
                  <p className="text-gray-600 mb-2">
                    5+ years of Real Estate experience
                  </p>
                  <p className="text-gray-600">
                    Leading plotting and housing projects in Indore &
                    Narmadapuram, MP
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 p-8 rounded-lg hover:shadow-lg transition-shadow duration-300">
              <h3 className="text-xl font-bold text-[#1B365D] mb-6">
                Core Team
              </h3>
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 rounded-full bg-[#1B365D] bg-opacity-10 flex items-center justify-center">
                    <i className="fas fa-drafting-compass text-2xl text-[#C5A572]"></i>
                  </div>
                </div>
                <div>
                  <h4 className="font-semibold text-[#1B365D] text-lg mb-2">
                    Ar. Siddharth Inani
                  </h4>
                  <p className="text-gray-600 mb-2">
                    B.Arch. from IIT Roorkee (Gold Medalist)
                  </p>
                  <p className="text-gray-600 mb-2">
                    Masters in Urban Planning from MANIT, Bhopal
                  </p>
                  <p className="text-gray-600">
                    Experience in landmark projects across Government and
                    private sector
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Footer */}
      <footer id="contact" className="bg-[#1B365D] text-white py-8 sm:py-12">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4">Elite Alumni Housing</h3>
              <p className="text-gray-300">
                Building premium communities for elite college alumni.
              </p>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li>
                  <a
                    href="#home"
                    className="text-gray-300 hover:text-[#C5A572]"
                  >
                    Home
                  </a>
                </li>
                <li>
                  <a
                    href="#about"
                    className="text-gray-300 hover:text-[#C5A572]"
                  >
                    About
                  </a>
                </li>
                <li>
                  <a
                    href="#locations"
                    className="text-gray-300 hover:text-[#C5A572]"
                  >
                    Locations
                  </a>
                </li>
                <li>
                  <a
                    href="#register"
                    className="text-gray-300 hover:text-[#C5A572]"
                  >
                    Register
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Contact</h4>
              <ul className="space-y-2">
                <li className="flex items-center">
                  <i className="fas fa-envelope mr-2 text-[#C5A572]"></i>
                  <a
                    href="mailto:hello@elitealumnihousing.com"
                    className="text-gray-300 hover:text-[#C5A572]"
                  >
                    hello@elitealumnihousing.com
                  </a>
                </li>
                <li className="flex items-center">
                  <i className="fas fa-phone mr-2 text-[#C5A572]"></i>
                  <a
                    href="tel:+917838178551"
                    className="text-gray-300 hover:text-[#C5A572]"
                  >
                    +91 78381 78551
                  </a>
                </li>
                <li className="flex items-center">
                  <i className="fas fa-location-dot mr-2 text-[#C5A572]"></i>
                    Sainath Buildcon & Real Estate Pvt Ltd 
18 - Scindhia Complex, Narmadapuram, MP 461001
                   
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Connect With Us</h4>
              <a
                href="https://wa.me/917838178551"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-6 py-3 bg-[#25D366] text-white rounded-button hover:bg-[#128C7E] transition-colors duration-300 whitespace-nowrap"
              >
                <i className="fab fa-whatsapp text-xl mr-2"></i>
                Connect on WhatsApp
              </a>
            </div>
          </div>
          <div className="border-t border-gray-700 mt-8 pt-8 text-center">
            <p className="text-gray-300">
              &copy; {new Date().getFullYear()} Elite Alumni Housing. All rights
              reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
